import React, { useState, useEffect } from 'react';
import celebrationImageSrc from '../../assets/img/6307846.png'; // Corrected path

// Helper functions to call global confetti functions from scripts.js
// These assume startConfetti and clearConfetti are globally available (e.g., window.startConfetti)
// or that scripts.js has been modified to expose them.
const triggerStartConfetti = (numParticles = 70) => {
    if (typeof window.startConfetti === 'function') {
        window.startConfetti(numParticles);
    } else {
        console.warn('startConfetti function not found. Ensure scripts.js is loaded and function is global.');
    }
};

const triggerClearConfetti = () => {
    if (typeof window.clearConfetti === 'function') {
        window.clearConfetti();
    }
};
function ThankYouModal({ show, onHide, onScheduleCall }) {
    const [modalState, setModalState] = useState('loading'); // 'loading', 'success'

    useEffect(() => {
        if (show) {
            setModalState('loading'); // Reset to loading when shown
            // Simulate API call or processing
            const timer = setTimeout(() => {
                setModalState('success');
                triggerStartConfetti(); // Trigger confetti when success state is reached
            }, 2500); // Simulate a 2.5-second delay

            return () => {
                clearTimeout(timer);
                triggerClearConfetti(); // Clear confetti if modal is hidden before success or on unmount
            };
        }
    }, [show]); // Only re-run if 'show' changes

    const handleScheduleAndClose = () => {
        if (onScheduleCall) {
            onScheduleCall();
        }
        onHide(); // Close the modal
    };


    if (!show) {
        return null;
    }

    return (
        <>
            <div
                className="modal fade show"
                style={{ display: 'block' }}
                id="thankYouModal" // Matches HTML
                tabIndex="-1"
                aria-labelledby="thankYouModalLabel"
                aria-modal="true"
                role="dialog"
            // data-bs-backdrop="static" // This behavior is implicitly handled by not calling onHide for backdrop clicks
            // data-bs-keyboard="false" // This behavior is implicitly handled by not having an onKeyDown listener for Esc
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center p-5">
                            {modalState === 'loading' && (
                                <div id="modalSpinner" className="mb-3">
                                    <div className="spinner-border spinner-theme-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                </div>
                            )}

                            {modalState === 'success' && (
                                <img src={celebrationImageSrc} alt="Celebración" id="celebrationImage" style={{ maxWidth: '120px', marginBottom: '1rem' }} />
                            )}

                            <h5 className="modal-title mb-3" id="thankYouModalLabel">
                                {modalState === 'loading' ? 'Procesando tus respuestas...' : '¡Muchas Gracias por tus Respuestas!'}
                            </h5>
                            <p id="modalMainText">
                                {modalState === 'loading' ? 'Estamos validando tus respuestas para entregarte la mejor ruta.' : 'Hemos recibido tus preferencias. Un asesor se pondrá en contacto contigo pronto.'}
                            </p>

                            {modalState === 'success' && (
                                <button type="button" className="btn btn-checkin mt-3" id="modalCloseButton" onClick={handleScheduleAndClose}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar-week me-2" viewBox="0 0 18 18">
                                        <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                    </svg>
                                    Agendar videollamada
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div> {/* Manually add backdrop */}
        </>
    );
}

export default ThankYouModal;
